import { render, staticRenderFns } from "./Sidenav.vue?vue&type=template&id=634012e7&scoped=true&"
import script from "./Sidenav.vue?vue&type=script&lang=ts&"
export * from "./Sidenav.vue?vue&type=script&lang=ts&"
import style0 from "./Sidenav.vue?vue&type=style&index=0&id=634012e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634012e7",
  null
  
)

component.options.__file = "Sidenav.vue"
export default component.exports